import PropTypes from 'prop-types';
import React from 'react';

// Components
import Annotation from './Annotation';
import Comment from './Comment';

// Actions
import { selectDesignComment } from '../actions/design-comments';

import connectToStores from 'fluxible-addons-react/connectToStores';
import DesignCollectionStore from '../stores/DesignCollectionStore';
import DesignCommentsStore from '../stores/DesignCommentsStore';

export default class AnnotationsCanvas extends React.Component {
    renderAnnotation(comment) {
        const isSelected =
            this.props.selectedComment && this.props.selectedComment.id === comment.id;

        let status = this.props.selectedCommentStatus;

        // Show read view if the selected comment is currently being edited elsewhere i.e the sidebar
        if (status === 'editing' && this.props.selectedCommentEditingLocation !== 'canvas') {
            status = null;
        }

        return (
            <Annotation
                isDeleting={status === 'deleting'}
                isSelected={isSelected}
                key={comment.id}
                onClick={this.props.onSelectDesignComment.bind(this, comment)}
                position={this.props.toScreenSpace(comment.annotation)}
            >
                <Comment
                    design={this.props.design}
                    hasExtraPadding={false}
                    comment={comment}
                    status={status}
                    isSelected={isSelected}
                    commentLocation="canvas"
                    canHighlight={false}
                    canShowAnnotationMarker={false}
                    isHeaderVisible={false}
                />
            </Annotation>
        );
    }

    render() {
        return this.props.annotations.map(comment => this.renderAnnotation(comment));
    }
}

AnnotationsCanvas.propTypes = {
    design: PropTypes.object.isRequired,
    selectedCommentEditingLocation: PropTypes.string,
    annotations: PropTypes.array,
    selectedComment: PropTypes.object,
    selectedCommentStatus: PropTypes.oneOf(['creating', 'editing', 'saving', 'deleting', 'error']),
    toScreenSpace: PropTypes.func.isRequired,
    onSelectDesignComment: PropTypes.func.isRequired,
};

export const ConnectedAnnotationsCanvas = connectToStores(
    AnnotationsCanvas,
    [DesignCollectionStore, DesignCommentsStore],
    (context, props) => {
        const selectedCommentEditingLocation = context.getStore(DesignCommentsStore)
            .selectedCommentEditingLocation;
        const comments = context.getStore(DesignCommentsStore).comments;
        const annotations = comments.filter(comment => Boolean(comment.annotation));

        return {
            selectedCommentEditingLocation: selectedCommentEditingLocation,
            annotations: annotations,
            selectedComment: context.getStore(DesignCommentsStore).selectedComment,
            selectedCommentStatus: context.getStore(DesignCommentsStore).selectedCommentStatus,
            onSelectDesignComment: comment => {
                context.executeAction(selectDesignComment, { comment });
            },
        };
    }
);
ConnectedAnnotationsCanvas.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func,
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/AnnotationsCanvas.jsx